import { useQuery } from '@tanstack/react-query';
import { useClient } from './useClient';
import { GetRulesNamesResponse } from '@hud/rules-dtos/api-rules.dtos';
export const RULES_NAMES_ID = 'rules-names';

export default function useRulesNames() {
  const { client, isReady } = useClient('detection');
  return useQuery({
    queryKey: [RULES_NAMES_ID],
    queryFn: async () => {
      const response = await client.get<GetRulesNamesResponse>('/rules-names');
      return GetRulesNamesResponse.parse(response.data);
    },
    enabled: isReady,
  });
}
